import { Grid, Typography } from '@material-ui/core'
import React, { useState } from 'react';
import "./AccordionRow.scss";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ChangeSystemPopUp from '../../../PopUps/ChangeSystemPopUp/ChangeSystemPopUp';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CircularWithValueLabel from '../../../Progress/CircularProgress/CircularProgress';
import useComponentVisible from '../../../../../hooks/useComponentVisible/useComponentVisible';
import { useDispatch, useSelector } from 'react-redux';
import { systemActionsCreator } from '../../../../../actions/customer/orderProcessSystemActions';

// ... (Keep your popUpDataMobileTablet and popUpDataDesktop arrays as they are)
const popUpDataMobileTablet = [
  {
    label: "Add System",
    icon: 'add'
  },
  {
    label: "Edit System",
    icon: 'edit'
  },
  {
    label: "Delete System",
    icon: 'delete'
  },
  {
    label: "Move Up",
    icon: 'up'
  },
  {
    label: "Move Down",
    icon: 'down'
  },
  {
    label: "Mark All Correct",
    icon: 'correct'
  },
  {
    label: "Mark All Incorrect",
    icon: 'incorrect'
  },
];

const popUpDataDesktop = [
  {
    label: "Add System",
    icon: 'add'
  },
  {
    label: "Edit System",
    icon: 'edit'
  },
  {
    label: "Delete System",
    icon: 'delete'
  },
  {
    label: "Move Up",
    icon: 'up'
  },
  {
    label: "Move Down",
    icon: 'down'
  },
  {
    label: "Mark All Correct",
    icon: 'correct'
  },
  {
    label: "Mark All Incorrect",
    icon: 'incorrect'
  },
]

function getBoxShadowByLayer(layer) {
  const layer1BoxShadow = 'rgba(0, 0, 0, 0) 0px 0px 0px';
  const layer2BoxShadow = 'rgba(62, 176, 167, 0.4) 3px 0px, rgba(62, 176, 167, 0.3) 4px 0px, rgba(62, 176, 167, 0.2) 5px 0px, rgba(62, 176, 167, 0.1) 6px 0px, rgba(62, 176, 167, 0.05) 7px 0px';
  const layer3BoxShadow = 'rgba(189, 22, 87, 0.4) 3px 0px, rgba(189, 22, 87, 0.3) 4px 0px, rgba(189, 22, 87, 0.2) 5px 0px, rgba(189, 22, 87, 0.1) 6px 0px, rgba(189, 22, 87, 0.05) 7px 0px';
  const layer4BoxShadow = 'rgba(62, 84, 176, 0.4) 3px 0px, rgba(62, 84, 176, 0.3) 4px 0px, rgba(62, 84, 176, 0.2) 5px 0px, rgba(62, 84, 176, 0.1) 6px 0px, rgba(62, 84, 176, 0.05) 7px 0px';
  const layer5BoxShadow = 'rgba(197, 50, 196, 0.4) 3px 0px, rgba(197, 50, 196, 0.3) 4px 0px, rgba(197, 50, 196, 0.2) 5px 0px, rgba(197, 50, 196, 0.1) 6px 0px, rgba(197, 50, 196, 0.05) 7px 0px';

  let boxShadow;
  switch (layer) {
    case 1:
      boxShadow = layer1BoxShadow;
      break;
    case 2:
      boxShadow = layer2BoxShadow;
      break;
    case 3:
      boxShadow = layer3BoxShadow;
      break;
    case 4:
      boxShadow = layer4BoxShadow;
      break;
    case 5:
      boxShadow = layer5BoxShadow;
      break;
    default:
      boxShadow = layer1BoxShadow;
      break;
  }

  return boxShadow;
}

function parsSystemName(details) {
  if (typeof (details) === 'object' && details.name) {
    return details.name;
  } else if (details) {
    return details;
  } else {
    return <span>&nbsp;</span>
  }
}

export default function AccordionRow(props) {
    const { view, isIcon, showNext, path, setSelectedParentSystem } = props;
    const { items: data, systemId, layer, checklistProgress, progressColor } = props.data;
    
    const [expandAccordion, setExpandAccordion] = useState(false);
    const [isViewAllDetails, setIsViewAllDetails] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, right: 0 });
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const dispatch = useDispatch();
    const systemsOpeningPath = useSelector((state) => state.orderProcessSystemReducer.systemsOpeningPath);

  // Helper to determine base class names without excessive ternaries
  const isTablet = view === 'tablet';
  const isMobile = view === 'mobile';
  
  // Dynamic Classes for State
  const mainClasses = `
    accordionRow__main 
    ${isTablet ? 'accordionRow__main--tablet' : ''} 
    ${isViewAllDetails ? 'accordionRow__main--expanded' : ''}
    ${expandAccordion ? 'accordionRow__main--active' : ''}
  `.trim();

  function addNextChildSystemToPath(toActive) {
    const dataToSend = {
      systemName: data[0]?.details,
      layer,
      isActive: toActive ? true : false
    };
    if (systemsOpeningPath.length > 0 && systemsOpeningPath[systemsOpeningPath.length - 1].layer === layer) {
      removeAllNextChildSystemOfPath(layer)
    }
    if (systemsOpeningPath.length > 0 && systemsOpeningPath[systemsOpeningPath.length - 1].layer > layer) {
      let removeSystemTillCurrentLayer = layer
      removeAllNextChildSystemOfPath(removeSystemTillCurrentLayer)
    }
    dispatch(systemActionsCreator.setSystemsOpeningPath(dataToSend))
  }

  function removeAllNextChildSystemOfPath(layer) {
    dispatch(systemActionsCreator.removeSystemFromOpeningPath(layer))
  }

  function handleShowNextLayer(e) {
    e.stopPropagation()
    setExpandAccordion(!expandAccordion)
    showNext(!expandAccordion)
    if (expandAccordion) {
      removeAllNextChildSystemOfPath(layer)
    } else {
      addNextChildSystemToPath(expandAccordion);
    }
  }

  function handleOpenSystemPopUp(e) {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const estimatedPopupHeight = 220;
    const shouldOpenAbove = rect.bottom + estimatedPopupHeight > window.innerHeight;
    setPopupPosition({
      top: shouldOpenAbove ? rect.top - estimatedPopupHeight : rect.bottom,
      right: window.innerWidth - rect.right
    });
    setIsComponentVisible(v => !v);
  }

  function handleViewAllDetails() {
    setIsViewAllDetails(!isViewAllDetails);
  }

  function remainingDetailsForMobile() {
    return data && [...data.slice(1, data.length)]
  }

  function handleOpenChecklistPopup() {
    const getCheckListBy = {
      systemId: systemId,
      parentSystemId: systemId,
      layer: layer,
      processId: props.process?.processId,
      path,
    }
    dispatch(systemActionsCreator.getCheckListBySystemId(getCheckListBy))
  }

  const nameColor = data && data[0]?.nameColor;
  const nameBackground = data && data[0]?.nameBackground;
  const name = data && data[0]?.name;
  const details = data && data[0]?.details;
  const tab_progress_view = isTablet ? 30 : 40;

  return (
    <>
      <Grid 
        container 
        spacing={0} 
        className={mainClasses}
        // Only keep inline style for dynamic shadow if necessary, otherwise move to CSS variables
        style={{ boxShadow: getBoxShadowByLayer(layer) }} 
        onClick={(e) => {
          e.stopPropagation();
          handleOpenChecklistPopup();
          addNextChildSystemToPath(true);
          if (setSelectedParentSystem) {
            setSelectedParentSystem(props.data.parentId);
          }
        }}
      >
        {/* Icon Column */}
        <Grid className={`accordion__col-1 ${isTablet ? 'accordionRow__col--tablet' : 'accordion__iconContainer__mobile'}`}>
          {isIcon && (
            <div
              className={`accordion__icons_container ${isTablet ? 'accordion__icons_container--tablet' : ''}`}
              onClick={(e) => handleShowNextLayer(e)}
            >
              {expandAccordion ? 
                <RemoveIcon className={`accordion__icon ${isTablet ? 'accordion__icon--tablet' : ''}`} /> : 
                <AddIcon className={`accordion__icon ${isTablet ? 'accordion__icon--tablet' : ''}`} />
              }
            </div>
          )}
        </Grid>

        {/* Main Content Column (System Name) */}
        <Grid className={`accordion__col-3 accordionRow__col ${isTablet ? 'accordionRow__col--tablet accordion__col-3--tablet' : ''}`}>
          <div className='accordionRow__col__content'>
            <Typography className={`accordionRow__col__name ${isTablet ? 'accordionRow__col__name--tablet' : ''}`}>
              <span className="badge-system" style={{ color: nameColor, background: nameBackground }}>
                {name}
              </span>
            </Typography>
            <span className={`accordionRow__col__text accordion__text-truncate ${isTablet ? 'accordionRow__col__text--tablet' : ''}`}>
              {parsSystemName(details)}
            </span>
          </div>
        </Grid>

        {/* Dynamic Data Columns */}
        {data && data.length > 1 && data.slice(1, data.length).map((item, index) => (
          <Grid key={index} className='accordion__col-3 accordionRow__col'>
            <div className='accordionRow__col__content'>
              <Typography className='accordionRow__col__name'>
                <span className="badge-label" style={{ color: item.nameColor, background: item.nameBackground }}>
                  {item.name}
                </span>
              </Typography>
              <span className='accordionRow__col__text accordion__text-truncate' title={item.details || ''}>
                {item.details ? item.details : <span>&nbsp;</span>}
              </span>
            </div>
          </Grid>
        ))}

        {/* Actions Column (Progress & Menu) */}
        <Grid className={`accordion__col-2 ${isTablet ? 'accordion__col-2--tablet' : 'accordion__progress--alignment'}`}>
          <Grid className={`accordionRow__menuProgress ${isTablet ? 'accordionRow__menuProgress--tablet' : ''} ${isMobile && isViewAllDetails ? 'accordion__progress--mobileViewExpand' : ''}`}>
            <Grid className="progress-wrapper">
              <CircularWithValueLabel 
                data={checklistProgress} 
                progress_color={progressColor} 
                diameter={tab_progress_view} 
              />
            </Grid>
            <Grid 
              className={`accordion__menuIcon_container ${isTablet ? 'accordion__menuIcon_container--tablet' : ''}`}
              ref={ref}
              onClick={(e) => {
                handleOpenSystemPopUp(e)
                if (setSelectedParentSystem) {
                  setSelectedParentSystem(props.data.parentId);
                }
              }}
            >
              {isComponentVisible && (
                <div ref={ref} style={{ position: 'fixed', top: popupPosition.top, right: popupPosition.right, zIndex: 999 }}>
                  <ChangeSystemPopUp
                    data={isMobile || isTablet ? popUpDataMobileTablet : popUpDataDesktop}
                    id={systemId}
                    handleViewAllDetails={handleViewAllDetails}
                    view={view}
                    rowIndex={props.rowIndex}
                    layer={layer}
                    clickHandlers={props.popupClickHandlers}
                     onItemClick={(icon) => {
                        const handlerName = icon === 'correct' ? 'Mark All Correct' : icon === 'incorrect' ? 'Mark All Incorrect' : null;
                        const handler = handlerName ? props.popupClickHandlers?.[handlerName] : null;
                        if (handler) {
                            handler(systemId, layer, path);
                        }
                    }}
                  />
                </div>
              )}
              <MoreVertIcon className='accordion__menuIcon__icon' />
            </Grid>
          </Grid>
        </Grid>

        {/* Expanded View Details */}
        {isViewAllDetails && remainingDetailsForMobile().length > 0 && (
          <>
            {remainingDetailsForMobile().map((item, index) => (
              <Grid key={index} className={`accordion__col-5 accordionRow__col accordionRow__viewAllDetails ${isTablet ? 'accordion__col-5--tablet accordionRow__viewAllDetails--tablet' : ''}`}>
                <div className='accordionRow__col__content'>
                  <Typography className={`accordionRow__col__name ${isTablet ? 'accordionRow__col__name--tablet' : ''}`}>
                    <span className="badge-label" style={{ color: item.nameColor, background: item.nameBackground }}>
                      {item.name}
                    </span>
                  </Typography>
                  <span className={`accordionRow__col__text accordion__text-truncate ${isTablet ? 'accordionRow__col__text--tablet' : ''}`}>
                    {item.details}
                  </span>
                </div>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </>
  )
}